import(/* webpackMode: "eager", webpackExports: ["ClientLink"] */ "/vercel/path0/app/_components/Collabo/Hero/_components/ClientLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Collabo/Hero/aqua.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Collabo/Hero/basic_collabo_banner.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Collabo/Hero/fuji.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Collabo/Hero/jellyview2.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Collabo/Hero/lotte.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Collabo/Hero/spacev.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Collabo/Hero/three.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Collabo/HighlightCollabo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Collabo/OpenCollabo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Event/Event/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Card"] */ "/vercel/path0/app/_components/Home/News/Guide/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Section/FAQSection/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Section/LicensingSolution/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Section/NewsLetter/NewsLetterSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/I18nTranslator/I18nTranslatorClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/ably.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/bymono.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/casetify.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/crazymin.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/cu.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/folder.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/gosty.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/haru_film.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/hnf.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/inupt.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/kfesta.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/kyobo.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/lespace.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/life4.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/loft.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/lotte_world.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/lotte.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/miniso.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/neople.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/nlize.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/olive0.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/photo_widget.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/_components/Shared/Partners/starfield.png");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/app/_primitives/Button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.2_@babel+core@7.26.9_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@14.2.2_@babel+core@7.26.9_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
